export default __webpack_public_path__ + "static/media/Manahil Sikandar.d51722d8.jpeg";